import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const resetPassword = async (body) => {
  const response = await axiosInstance.post(API.FORGOT_PASSWORD.RESET_PASSWORD, body);
  return response;
};
export const sendResendLink = async (email) => {
  const response = await axiosInstance.get(API.FORGOT_PASSWORD.SEND_PASSWORD + email);
  return response;
};

export const verifyUser = async (body) => {
  const response = await axiosInstance.post(API.ADMIN.VERIFY_ADMIN, body);
  return response;
};
